// src/hooks/useTickerFilingsSummary.js
// SEC-FILINGS-PAGE — new file.
//
// Confirmed design (found in project chat history): grouped by filingLabel,
// each group with its own EDGAR direct-search link — NOT the paginated
// browse-page feed. Deliberately a separate hook from useFilingsData rather
// than forcing one hook to serve two different response shapes.

import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export function useTickerFilingsSummary(ticker, token) {
  const [cik, setCik] = useState(null);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!ticker) { setLoading(false); return; }
    let cancelled = false;
    setLoading(true);
    setError('');

    const headers = token ? { Authorization: 'Bearer ' + token } : {};

    fetch(API_URL + '/api/filings/ticker/' + encodeURIComponent(ticker), { headers })
      .then(r => r.json())
      .then(d => {
        if (cancelled) return;
        if (d.success) {
          setCik(d.cik || null);
          setGroups(d.groups || []);
        } else {
          setError('Filings unavailable');
        }
      })
      .catch(() => { if (!cancelled) setError('Filings unavailable'); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [ticker, token]);

  return { cik, groups, loading, error };
}
